export enum PartyRelationshipTypeEnum {
	SELF = 'SELF',
	DIRECTOR = 'DIRECTOR',
	SHAREHOLDER = 'SHAREHOLDER',
	OWNER = 'OWNER',
	SIGNING_OFFICER = 'SIGNING_OFFICER'
}
